import type { StorageStatus } from '../storage'

/** Screen-sized badge shared by both views. Labels make color nonessential. */
export function drawStorageWarning(ctx: CanvasRenderingContext2D, x: number, y: number, status: StorageStatus): void {
  if (status.level === 'normal') return
  const critical = status.level === 'critical'
  const color = critical ? '#ff756b' : '#f1c65c'
  const label = status.full ? 'Full' : `${Math.min(99, Math.floor(status.used / status.capacity * 100))}%`
  ctx.save()
  ctx.font = '600 11px system-ui, sans-serif'
  ctx.textAlign = 'left'
  ctx.textBaseline = 'middle'
  const width = ctx.measureText(label).width + 37
  const left = x - width / 2
  ctx.fillStyle = critical ? 'rgba(54,16,14,.96)' : 'rgba(42,33,12,.96)'
  ctx.strokeStyle = color
  ctx.lineWidth = 1.2
  ctx.beginPath(); ctx.roundRect(left, y - 12, width, 24, 7); ctx.fill(); ctx.stroke()
  // Draw the warning mark as geometry so red never becomes a yellow emoji.
  const iconX = left + 14
  ctx.fillStyle = color
  ctx.beginPath(); ctx.moveTo(iconX, y - 7); ctx.lineTo(iconX + 7, y + 6); ctx.lineTo(iconX - 7, y + 6); ctx.closePath(); ctx.fill()
  ctx.fillStyle = critical ? '#36100e' : '#2a210c'
  ctx.fillRect(iconX - .8, y - 3, 1.6, 4)
  ctx.fillRect(iconX - .8, y + 2.5, 1.6, 1.6)
  ctx.fillStyle = color
  ctx.fillText(label, left + 27, y)
  ctx.restore()
}
